export default __webpack_public_path__ + "static/media/congratzBig.ac5b8eca.svg";